import { Dialog, IconButton } from '@mui/material';
import { styled } from '@mui/material/styles';

export const DialogRoot = styled(Dialog, {
  shouldForwardProp: prop => prop !== '$showCloseButton',
})<{ $showCloseButton: boolean }>(({ theme, $showCloseButton }) => ({
  '& .MuiDialogTitle-root': {
    padding: theme.spacing(2),
    paddingRight: $showCloseButton ? '56px' : theme.spacing(3),
    fontWeight: theme.typography.fontWeightMedium,
  },
  '& .MuiDialogContent-root, & .MuiDialogActions-root': {
    padding: theme.spacing(2),
  },
}));

export const CloseButton = styled(IconButton)(({ theme }) => ({
  position: 'absolute',
  right: theme.spacing(1),
  top: theme.spacing(1),
  color: theme.palette.grey[500],
  '&.Mui-disabled': {
    opacity: 0.3,
  },
}));
